const discoveryUrl = "https://kcmgp1617b2cqua.b2clogin.com/kcmgp1617b2cqua.onmicrosoft.com/610f6226-9cbd-482a-abb4-4f4c7d7e83fb/v2.0/.well-known/openid-configuration?p=b2c_1_opus_signupsignin"

export const environment = {
  production: false,
  apiUrl: 'https://api-qua.gpe16-17.keolis-idf.com/api/v1/opus',
  discoveryUrl: discoveryUrl,
  issuerNameB2c: 'kcmgp1617b2cqua.b2clogin.com',
  issuerNameOnMicrosoft: 'kcmgp1617b2cqua.onmicrosoft.com',
  subscriptionKey: '59d16fc1879946d884b4da0e4ead1bcd',
  idp: {
    issuer: "https://kcmgp1617b2cqua.b2clogin.com/610f6226-9cbd-482a-abb4-4f4c7d7e83fb/v2.0/",
    redirectUri: window.location.origin + "/",
    clientId: "d92d9a77-dafa-49cd-a8df-101e51e4750b",
    scope: `openid profile email offline_access`,
    responseType: "code",
    showDebugInformation: true,
    strictDiscoveryDocumentValidation: false,
    postLogoutRedirectUri: window.location.origin + "/",
    tokenEndpoint: "https://kcmgp1617b2cqua.b2clogin.com/kcmgp1617b2cqua.onmicrosoft.com/oauth2/v2.0/token?p=b2c_1_opus_signupsignin",
  },
};

